module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/technical/boq-item/boqitem-grid/boqitem-grid.component.css
// module id = ./src/app/technical/boq-item/boqitem-grid/boqitem-grid.component.css
// module chunks = main